export default {
      id: "touch-pointer-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "/gfx/iconset.13.17.6.svg#touch-pointer",
      toString: function () {
        return this.url;
      }
    }